import { map } from 'rxjs/operators';
import { ApiResult, IApiError } from '../models/api-result.model';

export const checkStatus = <T>() => {
  return map<ApiResult<T>, T>((rsp: ApiResult<T>) => {
    if (rsp.success)
      return rsp.data as T;

    throw new ApiResultError(rsp);
  });
}

export class ApiResultError extends Error {
  constructor(rsp: IApiError) {
    super(rsp.error);
  }
}
